import React from "react";
import styles from "../styles/sideBarButton.module.css";
import { useNavigate } from "react-router-dom";

const SideBarButton = ({ title, path, logoutUser, parentLoc }) => {
  const navigate = useNavigate();
  const nextPath = () => {
    if (path === "/logout") {
      logoutUser();
    } else {
      navigate(path);
    }
  };

  const buttonStyle =
    parentLoc === path ? styles.buttonStyleActive : styles.buttonStyle;
  const titleStyle =
    parentLoc === path ? styles.titleStyleActive : styles.titleStyle;

  return (
    <button className={buttonStyle} onClick={() => nextPath()}>
      <h3 className={titleStyle}>{title}</h3>
    </button>
  );
};

export default SideBarButton;
